import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-west-virginia-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./west-virginia-state-form.component.html",
  styleUrl: "./west-virginia-state-form.component.scss",
})
export class WestVirginiaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
